import styled from 'styled-components';

const StyledPromptFooter = styled.div`
  padding: 6px;
  background-color: #F5F5F5;
  font-size: 8px;
  text-align: center;
  font-weight: 700;

  a {
    color: #000;
  }

  .dcinnovation {
    text-decoration: none;
  }
`;

export default StyledPromptFooter;